module.exports = __webpack_public_path__ + "KI.png?b89fedc358b4e9eb7d93553b7a19f9ed";